import React from "react";
import styles from "./QuoteCard.module.scss";
import { paymentContent } from "../../PaymentOptions/tradeInCopyText";
import classNames from "classnames";
import { AvailablePaymentOption } from "../../PaymentOptions/PaymentOptions";
import { GradingQuestions, GradingAnswer } from "../../Grading/types";
import SeeYourAnswers from "../SeeYourAnswers/SeeYourAnswers";
import TermsAndConditions from "../TermsAndConditions/TermsAndConditions";

export const formatDateLongMonth = (
  date: string | number | Date,
  includeYear = false,
): string => {
  const options: Intl.DateTimeFormatOptions = { month: "long", day: "numeric" };
  if (includeYear) options.year = "numeric";

  const dateObj: Date = new Date(date);
  return dateObj.toLocaleDateString("en-GB", options);
};

const isExpiredDate = (expiry: string | number | Date): boolean => {
  const currentDate: Date = new Date();
  const expiryDate: Date = new Date(expiry);
  return currentDate > expiryDate;
};

type Props = {
  title: string;
  deviceName: string;
  expiry: string;
  payment: AvailablePaymentOption;
  instructions?: string;
  ctaButton?: React.ReactNode;
  removeIconButton?: React.ReactNode;
  gradingQuestions?: GradingQuestions[];
  gradingAnswers?: GradingAnswer[];
  showTC?: boolean;
};

export const QuoteCard = ({
  title,
  deviceName,
  expiry,
  payment,
  instructions,
  gradingAnswers,
  gradingQuestions,
  ctaButton,
  removeIconButton,
  showTC,
}: Props) => {
  const hasExpired = isExpiredDate(expiry);
  return (
    <div
      className={classNames(
        styles.quote,
        hasExpired && styles["quote--expired"],
      )}
    >
      {removeIconButton}

      <h2 className={styles.quote__valueLabel}>
        {hasExpired ? `Expired ${formatDateLongMonth(expiry)}` : title}
      </h2>

      <div
        className={styles.quote__inner}
        data-cy={`quote-paymentType-${payment?.type}`}
      >
        <h2 className={styles.quote__description}>{deviceName}</h2>
        <h3 className={styles.quote__value}>{payment.displayValue}</h3>

        <p className={styles.quote__type}>
          {paymentContent[payment.type].payout}
        </p>
      </div>
      <div className={styles.quote__footNote}>
        {!hasExpired && (
          <p>
            Valid until <b>{formatDateLongMonth(expiry)}</b>
          </p>
        )}
      </div>
      {gradingAnswers && (
        <SeeYourAnswers questions={gradingQuestions} answers={gradingAnswers} />
      )}
      {showTC && <TermsAndConditions />}
      {instructions && <p className={styles.quote__message}>{instructions}</p>}
      {ctaButton}
    </div>
  );
};
export default QuoteCard;
